import {
  compareStrings,
  displayTranslations,
  getArtwork,
  parseCategoryName,
  parseLanguage,
  titleize
} from "../../utils/utils";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import GameNameParser from "./GameNameParser";
import React, { useState } from "react";
import ExpansionIcon from "./ExpansionIcon";
import LanguageFlag from "./LanguageFlag";

const  BlueprintImageTableRaw = ({
    blueprintImage,
    handleShowLargeImage,
    hideGame,
    id,
    displayEra,
    compact,
    setFlawsToInspect
  }) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)
  const expansionNames = displayTranslations(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)



  return (
    <React.Fragment>
      <td className="text-center">
        <ShowBlueprintImageFrontImage
          size={"thumb"}
          blueprintImage={blueprintImage}
          handleShowLargeImage={handleShowLargeImage}
          additionalClasses={blueprintImage.is_graded_image ? (blueprintImage.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "thumb-image-graded-booster-pack m-auto" : "thumb-image-graded-card m-auto") : ''}
          setFlawsToInspect={setFlawsToInspect}
        />
      </td>
      <td className="text-left ml-td">
        <div className={`mb-0 ${compact ? 'text--size-small' : ''}`}>
          <div className="d-flex align-items-center">
            <span className="mr-2">
              { parseLanguage(blueprintImage.language_filter) }
            </span>

            <LanguageFlag
              language={blueprintImage.language}
              maxHeight={'15px'}
            />
          </div>
        </div>
        <p className={`mb-0 ${compact ? 'text--size-small' : ''}`}>{titleize(blueprintImage.version)}</p>
        {
          blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
          <React.Fragment>
            <span className={`mb-0 ${compact ? 'text--size-small' : ''}`}>{titleize(blueprintImage.rarity)}</span>
            {
              blueprintImage.rarity_logo_url &&
                <img src={blueprintImage.rarity_logo_url} alt="" className="ml-1 mb-1"
                     style={{ maxWidth: "15px" }} />
            }
          </React.Fragment>
        }
        {blueprintImage.edition && blueprintImage.edition !== "Undefined" &&
          <p className={`${compact ? 'text--size-small' : ''}`}>{blueprintImage.edition}</p>
        }
      </td>
      <td className="text-center ml-td">
        {blueprintImageNames.length > 1 ?
          <React.Fragment>
            <p className={`${compact ? 'text--size-small' : ''}`}>
              { blueprintImageNames[0] }
            </p>
            <p className="text--size-small">
              ({ blueprintImageNames[1] })
            </p>
          </React.Fragment>
          :
          <p id={"name_" + id} className={`${compact ? 'text--size-small' : ''}`}>
            { blueprintImageNames[0] }
          </p>
        }
        <p className={`${compact ? 'text--size-small' : ''}`}>{blueprintImage.collector_number}</p>

        {
          getArtwork(blueprintImage) ?
            <p><small>[{getArtwork(blueprintImage)}]</small></p> : <React.Fragment></React.Fragment>
        }

        {
          blueprintImage.print_sheet_code &&
            <p><small>{blueprintImage.print_sheet_code}</small></p>
        }
      </td>
      {
        compact ?
          <React.Fragment>
            <td className="text-center ml-td text-nowrap">
              {
                !hideGame &&
                <p className="text--size-small">
                  <GameNameParser
                    game_name={blueprintImage.game.name}
                    additionalClasses1={"mb-0"}
                  />
                </p>
              }
              <p className="text--size-small">
                { parseCategoryName(blueprintImage.blueprint.category.name) }
              </p>
            </td>
            <td className="text-center ml-td">
              {
                displayEra &&
                  <React.Fragment>
                    {
                      (blueprintImage.en_era_name || blueprintImage.era_name) &&
                      <small>
                        {
                          eraNames.length > 1 ?
                            <React.Fragment>
                              <p className="mb-0">
                                { eraNames[0] }
                              </p>
                              <p className="text--size-small">
                                ({ eraNames[1] })
                              </p>
                            </React.Fragment>
                            :
                            <p className="mb-0">
                              { eraNames[0] }
                            </p>
                        }<br/>
                      </small>
                    }
                  </React.Fragment>
              }
              {
                expansionNames.length > 1 ?
                  <small>
                    <p className="mb-0">
                      { expansionNames[0] }
                    </p>
                    <p className="text--size-small">
                      ({ expansionNames[1] })
                    </p>
                  </small>
                  :
                  <small>
                    { expansionNames[0] }
                  </small>
              }

              <ExpansionIcon
                icon_url={blueprintImage.expansion.icon_url}
                width={"25px"}
              />
            </td>
          </React.Fragment>
        :
          <React.Fragment>
            {
              !hideGame &&
              <td className="text-center ml-td">
                <GameNameParser
                  game_name={blueprintImage.game.name}
                  additionalClasses1={"mb-0"}
                />
              </td>
            }
            <td className="text-center ml-td">
              {parseCategoryName(blueprintImage.blueprint.category.name)}
            </td>
            {
              displayEra &&
              <td className="text-center ml-td">
                {
                  (blueprintImage.en_era_name || blueprintImage.era_name) &&
                  <React.Fragment>
                    {
                      eraNames.length > 1 ?
                        <React.Fragment>
                          <p className="mb-0">
                            { eraNames[0] }
                          </p>
                          <p className="text--size-small">
                            ({ eraNames[1] })
                          </p>
                        </React.Fragment>
                        :
                        <p className="mb-0">
                          { eraNames[0] }
                        </p>
                    }
                  </React.Fragment>
                }
              </td>
            }

            <td className="text-center">
              {
                expansionNames.length > 1 ?
                  <React.Fragment>
                    <p className="mb-0">
                      { expansionNames[0] }
                    </p>
                    <p className="text--size-small">
                      ({ expansionNames[1] })
                    </p>
                  </React.Fragment>
                  :
                  <p>
                    { expansionNames[0] }
                  </p>
              }

              <ExpansionIcon
                icon_url={blueprintImage.expansion.icon_url}
                width={"25px"}
              />
            </td>
          </React.Fragment>
      }
    </React.Fragment>
  );
}

export default  BlueprintImageTableRaw;
